<template>
    <div>
        <div class="dataTitle">
            <div class="title">{{title}}</div>
            <div style="display: flex;justify-content: center;align-items: center;">
                <InputField label="" type="text" label-width="0%" id="waterBodyName" style="margin-right: 1rem;"
                            :modelValue="preForm.waterBodyName" placeholder="请输入水体名称"
                            @update:modelValue="(value) => handleModelPreValueUpdate('waterBodyName', value)"/>
                <a-space>
                    <ButtonField style="width: 80px;" text="查询" secondary @click="getWatStaPlaPageList"/>
                    <ButtonField style="width: 80px;" text="新增" @click="add" primary />
                </a-space>
            </div>
        </div>
        <Tablelist
            :showCheckbox="false"
            :list="list"
            :columns="tableColumns"
            :totalSize="preForm.totalSize"
            :totalPages="preForm.totalPages"
            :pageNum="preForm.pageNum"
            :pageSize="preForm.pageSize"
            @page-change="onChange"
        >
            <template v-slot:actions="{ item }">
                <a-space>
                    <a href="#" @click.prevent="editText(item)">编辑</a>
                    <a href="#" class="danger" @click.prevent="deleteText(item)">删除</a>
                </a-space>
            </template>
        </Tablelist>
        <Modal v-if="visible" v-model="visible"
               :visible="visible"
               :title="editShow?'编辑水体现状与规划':'新增水体现状与规划'"
               :showFooter="false"
               :overlayOpacity="0.5"
               :contentWidth="'50%'"
               @update:visible="visible = $event">
            <form>
                <div class="formDiv">
                    <div>
                        <InputField label="水体名称" type="text"  id="waterBodyName"
                                    :modelValue="form.waterBodyName" placeholder="请输入水体名称"
                                    @update:modelValue="(value) => handleModelValueUpdate('waterBodyName', value)"/>
                    </div>
                    <div>
                        <SelectField label="水体类型" id="type" placeholder="水体类型"
                                     :modelValue="form.waterBodyType" :options="waterBodyList"
                                     @update:modelValue="(value) => handleModelValueUpdate('waterBodyType', value)"/>
                    </div>
                </div>
                <div class="formDiv">
                    <div>
                        <InputField label="河道断面形式" type="Number"  id="crossSection"
                                    :modelValue="form.crossSection" placeholder="请输入河道断面形式"
                                    @update:modelValue="(value) => handleModelValueUpdate('crossSection', value)"/>
                    </div>
                    <div>
                        <InputField label="河道纵坡(‰)" type="Number"  id="gradeLine"
                                    :modelValue="form.gradeLine" placeholder="请输入河道纵坡(‰)"
                                    @update:modelValue="(value) => handleModelValueUpdate('gradeLine', value)"/>
                    </div>
                </div>
                <div style="display: flex;justify-content: center;">
                    <a-space>
                        <ButtonField text="关闭" @click="cancel" secondary />
                        <ButtonField text="保存" v-if="!saveShow" primary @click="handleSubmit"/>
                        <ButtonField text="下一步" v-else primary @click="handleNextStep"/>
                    </a-space>
                </div>
            </form>
        </Modal>
    </div>
</template>

<script>
import { fetchWatStaPlaPageList,saveWatStaPlaPage,modifyWatStaPlaPage,remove} from "@/views/diagnose/api/diagnose";

export default {
    name: "index",
    data() {
        return {
            preForm:{
                totalSize: 1,
                totalPages: 1,
                pageNum: 1,
                pageSize: 10,
            },
            form:{
                waterBodyName:null,waterBodyType:null,crossSection:null,gradeLine:null
            },
            visible:false,
            editShow:false,
            saveShow:false,
            waterBodyList:[
                {name:'河道',value:1},{name:'湖泊',value:2},{name:'塘库',value:3},
            ],
            list:[],
            tableColumns:[
                {key: 'waterBodyName',title: '水体名称',field: 'waterBodyName',width: '100px'},
                {key: 'waterBodyType',title: '水体类型',field: 'waterBodyType',width: '100px'},
                {key: 'crossSection',title: '河道断面形式',field: 'crossSection',width: '100px'},
                {key: 'gradeLine',title: '河道纵坡（‰）',field: 'gradeLine',width: '100px'},
                {key: 'actions',title: '操作',field: 'actions', infotype: 'template',width: '100px'},
            ]
        }
    },
    props:{
        title: {
            type: String,
            default: null,
        },
    },
    mounted() {
        this.getWatStaPlaPageList();
    },
    methods: {
        formatDate(dateString){
            const date = new Date(dateString);
            return date.toISOString().split('T')[0];
        },
        onChange(pagination) {
            this.preForm.pageNum  = pagination;
            this.preForm.pageSize = 10;
            this.getWatStaPlaPageList();
        },
        getWatStaPlaPageList(){
            fetchWatStaPlaPageList(this.preForm).then(res => {
                this.list = res.list.map(item => ({
                    ...item,
                    daytime: this.formatDate(item.daytime)
                }));
                this.preForm.totalPages = res.totalPages;
                this.preForm.totalSize = res.totalSize;
            })
        },
        handleModelPreValueUpdate(fieldName, value){
            this.preForm[fieldName] = value;
        },
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        add(){
            this.visible = true;
            this.editShow = false;
            this.saveShow = false;
            this.form = {}
        },
        editText(item){
            console.log("item:::",item)
            this.visible = true;
            this.editShow = true;
            this.saveShow = false;
            this.form = item;
        },
        deleteText(item){
            console.log("item:::",item)
            remove({
                id: item.id,
                type: "diagnose_wat_sta_pla"
            }).then((res) => {
                console.log("res:", res);
                this.getWatStaPlaPageList();
            }).catch((error) => {
                console.error("删除失败:", error);
            });
        },
        cancel() {
            this.visible = false;
        },
        handleSubmit(){
            this.form.daytime = new Date();
            if(this.form.id){
                modifyWatStaPlaPage(this.form).then(res => {
                    console.log("modifySewagePage   res:::",res)
                    this.getWatStaPlaPageList()
                })
            }else{
                saveWatStaPlaPage(this.form).then(res => {
                    console.log("saveSewagePage   res:::",res)
                    this.getWatStaPlaPageList()
                })
            }
            this.saveShow = true
        },
        handleNextStep(){
            this.visible = false;
            this.$bus.$emit('switch-component', 'drainPart');
        }
    }
}
</script>
<style scoped>
.dataTitle{
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin:0 0 1rem 0;
}
.title{
    font-size: 1.2rem;
    color: #00ff96;
    font-weight: bold;
}
.formDiv{
    display: flex;
    justify-content: space-between;
    margin: 1rem 0;
}
.formDiv > div{
    width: 48%;
}
</style>